<template>
  <CarSearch
    :disable="isExistingQuoteOpen || applicationSaving"
    :loading-makes="loadingMakes"
    :saving="applicationSaving"
    :makes="makeList"
    :body-types="getBodyList"
    :loading-models="loadingModels"
    :models="modelList"
    :transmissions="getTransmissionList"
    :years="getYearList"
    :find-car="selected"
    :search-disable="!validCarSearch || isExistingQuoteOpen"
    @next:searchDetail="searchDetail"
    @update:bodyType="setBodyTypeSelected($event)"
    @update:newUsed="setNewUsed"
    @update:make="setMakeSelected($event)"
    @update:model="setModelSelected($event)"
    @update:transmission="setTransmission($event)"
    @update:year="setSelected(['year', $event])"
  />
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import validations from './validations';

export default {
  name: 'CarSearchWidget',
  metaInfo: {
    title: 'Car Search |'
  },
  data() {
    return {
      updateApplicationPaths: this.$Constants.APPLICATION_UPDATE_PATHS.carSearch
    };
  },
  validations,
  computed: {
    ...mapGetters('carSearch', [
      'getBodyList',
      'getTransmissionList',
      'getYearList',
      'validCarSearch',
      'selected'
    ]),
    ...mapState({
      applicationSaving: (state) => state.application.applicationSaving,
      loadingMakes: (state) => state.carSearch.loadingMakes,
      loadingModels: (state) => state.carSearch.loadingModels,
      makeList: (state) => state.carSearch.makeList || [],
      modelList: (state) => state.carSearch.modelList || []
    }),
    ...mapGetters('quote', ['isExistingQuoteOpen'])
  },
  watch: {
    async 'selected.makeId'() {
      await this.getModels();
    },
    async 'selected.bodyType'() {
      await this.getModels();
    },
    async 'selected.newUsed'() {
      await this.getModels();
    }
  },
  methods: {
    ...mapMutations('carSearch', [
      'setNewUsedSelected',
      'setMakeSelected',
      'setBodyTypeSelected',
      'setModelSelected',
      'setTransmission',
      'setSelected'
    ]),
    ...mapMutations('application', ['updateCustomerOption']),
    ...mapActions('carSearch', ['getMakes', 'getModels']),
    ...mapActions('application', ['updateApplication']),
    async searchDetail() {
      await this.updateApplication({
        updateApplicationPaths: this.updateApplicationPaths
      });
      await this.$router.push({
        name: this.$RouteNames.carSearchVariant,
        params: { ...this.$router.currentRoute.params }
      });
    },
    setNewUsed(value) {
      this.updateCustomerOption({ field: 'vehicleCondition', value });
      this.setNewUsedSelected(value);
    }
  },
  async beforeMount() {
    await this.getMakes();
    await this.getModels();
  },
  components: {
    CarSearch: () => import('../../components/page/car-search')
  }
};
</script>
